module.exports = __webpack_public_path__ + "static/media/paslon-1.aabcd6da.jpg";